import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=31bb15dc&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bb15dc')) {
      api.createRecord('31bb15dc', component.options)
    } else {
      api.reload('31bb15dc', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=31bb15dc&", function () {
      api.rerender('31bb15dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/platform/edit.vue"
export default component.exports